// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2D4d5","validationTips":"StatementDescriptor_validationTips__1hoJG"};